var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dashboardMessages && _vm.dashboardMessages.length > 0)?_c('v-container',_vm._l((_vm.dashboardMessages),function(message){return _c('v-card',{key:message},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(message)}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }